import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useRef, useState } from "react";
import MessageBox from "./MessageBox";
import { WebSocketProvider } from "../../Websocket/WebSocketProvider";
import "./GroupMessageBox.scss";
import { Skeleton, Typography } from "@mui/material";
import { Form } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";
import { useParams } from "react-router";
import OfferPercentage from "../../assets/images/icons/OfferPercentage.svg";
import SampleDrop from "../../assets/images/icons/Sample.svg";
import SellRequestSimple from "../../assets/images/icons/SellRequestSimple.svg";
import ShoppingCartSimple from "../../assets/images/icons/ShoppingCartSimple.svg";
import { CommonService } from "../../Service/CommonService";
import { MessageApiService } from "../../Service/MessageApiService";
import NoChatMessage from "../Common/NoChatMessage";
import NoGroupMessage from "../Common/NoGroupMessage";
import AdminMessageBox from "./AdminMessageBox";

const GroupMessageBox: React.FC<{}> = ({}) => {
  //requestId
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(false);
  const [groups, setGroups] = useState<any[]>([]);
  const [originalGroups, setOriginalGroups] = useState<any[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [search, setSearch] = useState("");
  const [isSeller, setIsSeller] = useState<boolean>(false);
  const [activeTab, setActiveTab] = useState("All");

  // Dynamic Height Calculation Start

  const [innerHeight, setInnerHeight] = useState(0);
  const innerRef = useRef<HTMLDivElement>(null);

  const [headerHeight, setHeaderHeight] = useState(0);
  const headerRef = useRef<HTMLDivElement>(null);

  const [tabContainerHeight, setTabContainerHeight] = useState(0);
  const tabContainerRef = useRef<HTMLDivElement>(null);

  // Function to calculate heights accurately
  const updateHeights = () => {
    if (innerRef.current) {
      // Use offsetHeight instead of clientHeight for more accurate measurement
      const newInnerHeight = innerRef.current.offsetHeight;
      setInnerHeight(newInnerHeight);
    }
    
    if (headerRef.current) {
      const newHeaderHeight = headerRef.current.offsetHeight;
      setHeaderHeight(newHeaderHeight);
    }
  };

  // Initial calculation after component mounts
  useEffect(() => {
    // Small delay to ensure DOM is fully rendered
    const timeoutId = setTimeout(updateHeights, 100);
    return () => clearTimeout(timeoutId);
  }, []);

  // Calculate tab container height when dependencies change
  useEffect(() => {
    if (innerHeight && headerHeight) {
      // Subtract header height and any additional spacing (e.g., 20px)
      const calculatedHeight = innerHeight - headerHeight - 20;
      
      // Ensure height is never negative
      const newHeight = Math.max(calculatedHeight, 0);
      
      console.log('Height calculation:', {
        innerHeight,
        headerHeight,
        calculatedHeight: newHeight
      });
      
      setTabContainerHeight(newHeight);
    }
  }, [innerHeight, headerHeight]);

  // Update heights on window resize
  useEffect(() => {
    const handleResize = () => {
      updateHeights();
    };
    
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


// Dynamic Height Calculation End
  useEffect(() => {
    loadMessages("All");
  }, []);

  const loadMessages = async (tab: string) => {
    try {
      setIsLoading(true);
      setActiveTab(tab);

      const response = await MessageApiService.getGroupsMessage(tab);

      if (response.data.length > 0) {
        response.data[0].unreadMessageCount = 0;
      }

      setSearch("");
      setOriginalGroups(response.data);
      setGroups(response.data);
      setSelectedGroup(response.data?.length ? response.data[0] : null);
      setIsSeller(response.data[0].hasSeller);

      setIsLoading(false);
    } catch (error) {
      console.log("error fetching data" + error);
      setIsLoading(false);
    }
  };

  const toTitleCase = (str: string) => {
    return str
      .replace(/_/g, " ") // Replace underscores with spaces
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  const handleSearch = (searchTerm) => {
    if (!searchTerm) {
      setGroups(originalGroups);
      setSelectedGroup(originalGroups?.length ? originalGroups[0] : null);

      return;
    }

    const lowerCaseSearch = searchTerm.toLowerCase();

    // Filter the groups based on search term
    const filteredGroups = originalGroups.filter(
      (row) =>
        row.requestNumber?.toLowerCase().includes(lowerCaseSearch) ||
        row.sendBy?.toLowerCase().includes(lowerCaseSearch) ||
        row.companyName?.toLowerCase().includes(lowerCaseSearch) ||
        row.requestType
          ?.toLowerCase()
          .replace(/_/g, " ")
          .includes(lowerCaseSearch) ||
        row.createdDate?.toLowerCase().includes(lowerCaseSearch)
    );

    console.log(filteredGroups);

    // Update state with filtered data
    setGroups(filteredGroups);
    setSelectedGroup(filteredGroups.length ? filteredGroups[0] : null);
  };

  // Filter rows based on search query
  // const filteredRows = groups.filter(
  //   (row) =>
  //   row.requestNumber?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.sendBy?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.companyName?.toLowerCase().includes(search?.toLowerCase()) ||
  //     row.requestType
  //       ?.toLowerCase()
  //       .replace(/_/g, " ")
  //       .includes(search?.toLowerCase()) ||
  //     row.createdDate?.toLowerCase().includes(search?.toLowerCase())
  // );

  // Map filtered rows with unique IDs
  // const groupsData = filteredRows.map((rowData, index) => ({
  //   ...rowData,
  // }));

  const setGroupMessagesAsRead = (group: any) => {
    const updatedGroups = groups.map((g) =>
      g.requestId === group.requestId ? { ...g, unreadMessageCount: 0 } : g
    );

    // Update state with the new groups array
    setGroups(updatedGroups);

    // Set the selected group
    setSelectedGroup(group);

    setIsSeller(group.hasSeller);
  };

  return (
    <div className="group-chat-wrapper" style={{minHeight:"calc(100vh - 81px)"}}>
      {CommonService.isAdmin() && (
        <Typography
          variant="h1"
          gutterBottom
          sx={{
            px: 1,
            mb: 2,
            fontSize: "25px",
            fontWeight: 600,
            color: "#333333",
          }}
        >
          Inbox
        </Typography>
      )}
      <div className="d-flex">
        <div className={`group-chat-container row d-flex flex-grow-1 m-0 ${CommonService.isUser() ? "user-group-chat-container": ""}`} ref={innerRef} style={{minHeight:"calc(100vh - 355px)"}}>
          {/* {isLoading ? (
            <>
              <Skeleton
                animation="wave"
                variant="rounded"
                style={{ height: "calc(100vh - 200px)" }}
                className="col-md-6 col-lg-5 col-xl-4 col-xxl-4 mb-3 mb-md-0"
              />
            </>
          ) : ( */}
            <div className="group-list-wrapper col-md-6 col-lg-5 col-xl-4 col-xxl-4 mb-3 mb-md-0">
              {/* {groups.map((group) => (
              <div
                key={group.requestId}
                className={`group-item ${selectedGroup?.requestId === group.requestId ? 'selected' : ''}`}
                onClick={() => setSelectedGroup(group)}
              >
                {group.sendBy}
              </div>
            ))} */}
            <div ref={headerRef}>
              {CommonService.isUser() && (
                <nav className="group-chat-nav-wrapper">
                  <div
                    className="nav nav-tabs justify-content-around mt-3"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      onClick={() => loadMessages("All")}
                      //className="nav-link active"
                      className={`nav-link ${
                        activeTab === "All" ? "active" : ""
                      }`}
                      id="nav-all-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-all"
                      type="button"
                      role="tab"
                      aria-controls="nav-all"
                      aria-selected="true"
                    >
                      All
                    </button>
                    <button
                      onClick={() => loadMessages("My Wearhouse")}
                      className={`nav-link ${
                        activeTab === "My Wearhouse" ? "active" : ""
                      }`}
                      //className="nav-link"
                      id="nav-warehouse-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-warehouse"
                      type="button"
                      role="tab"
                      aria-controls="nav-warehouse"
                      aria-selected="false"
                    >
                      As Owner
                    </button>
                    <button
                      onClick={() => loadMessages("My Requests")}
                      //className="nav-link"
                      className={`nav-link ${
                        activeTab === "My Requests" ? "active" : ""
                      }`}
                      id="nav-requests-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-requests"
                      type="button"
                      role="tab"
                      aria-controls="nav-requests"
                      aria-selected="false"
                    >
                      As Buyer
                    </button>
                  </div>
                </nav>
              )}

              <div className="position-relative mt-3">
                <Form.Control
                  type="text"
                  placeholder="Search"
                  className="chat-search mr-sm-2 pl"
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <SearchIcon
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "15px",
                    transform: "translateY(-50%)",
                  }}
                />
              </div>
              <div className="text-muted">
                <hr />
              </div>
              </div>
               {isLoading ? (
            <>
              <Skeleton
                animation="wave"
                variant="rounded"
                // style={{ height: "100%" }}
                className='inbox-skeleton'
              />
            </>
          ) : (
              <div className="tab-content" id="nav-tabContent">
                <>
                  <div
                    className="tab-pane fade show active"
                    id="nav-all"
                    role="tabpanel"
                    aria-labelledby="nav-all-tab"
                    tabIndex={0}
                  >
                    {/* {selectedGroup ? (  */}
                    <ListGroup className={`${groups.length <= 0 ? "d-none" : "d-block"}`} style={{height:`${tabContainerHeight}px`}} ref={tabContainerRef}>
                      {groups?.map((group, index) => (
                        <ListGroup.Item
                          className="cursor-pointer"
                          style={{
                            backgroundColor:
                              selectedGroup?.requestId === group.requestId
                                ? "white"
                                : "initial",
                          }}
                          onClick={() => {
                            setGroupMessagesAsRead(group);
                          }}
                        >
                          <div className="chat-info-wrapper py-2">
                            <div className="chat-info-inner flex-wrap flex-sm-nowrap">
                              <div className="d-flex align-items-start" style={{gap:"12px"}}>
                                <div className="avtar d-inline-flex justify-content-center align-items-center position-relative flex-shrink-0">
                                  {group?.sendBy?.charAt(0)}
                                  <span className="active-status online position-absolute top-0 start-0"></span>
                                </div>
                              
                                <div className="chat__info d-flex d-sm-block flex-column">
                                  {CommonService.isUser() &&
                                    !CommonService.isSameCompany(
                                      group.companyId
                                    ) && (
                                      <span className="chat__info--name">
                                        {" "}
                                        #{group.requestNumber}
                                      </span>
                                    )}
                                  {(CommonService.isAdmin() ||
                                    CommonService.isSameCompany(
                                      group.companyId
                                    )) && (
                                    <>
                                      <span className="chat__info--name">
                                        {group.sendBy}
                                      </span>
                                    </>
                                  )}

                                  <div>
                                    <div className="d-flex align-items-center">
                                      {(CommonService.isAdmin() ||
                                        CommonService.isSameCompany(
                                          group.companyId
                                        )) && (
                                        <>
                                          <p className="chat__info--company me-2 m-0">
                                            {group.companyName}
                                          </p>
                                          <span className="d-none d-sm-inline">
                                            |
                                          </span>
                                        </>
                                      )}

                                      <span className="chat__info--reqType ms-sm-2">
                                        {group.requestType ==
                                          "OFFER_REQUEST" && (
                                          <img
                                            src={OfferPercentage}
                                            alt="OfferPercentage"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SAMPLE_REQUEST" && (
                                          <img
                                            src={SampleDrop}
                                            alt="SampleDrop"
                                          />
                                        )}
                                        {group.requestType ==
                                          "ORDER_REQUEST" && (
                                          <img
                                            src={ShoppingCartSimple}
                                            alt="ShoppingCartSimple"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SELL_REQUEST" && (
                                          <img
                                            src={SellRequestSimple}
                                            alt="SellRequestSimple"
                                          />
                                        )}
                                        {toTitleCase(group.requestType)}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="ms-auto">
                                {(CommonService.isAdmin() ||
                                  CommonService.isSameCompany(
                                    group.companyId
                                  )) && (
                                  <>
                                    <span className="chat__info--name">
                                      #{group.requestNumber}
                                    </span>
                                  </>
                                )}
                                <div
                                  className="time__info d-flex flex-column text-end lh-base"
                                  style={{
                                    fontWeight:
                                      selectedGroup?.requestId ===
                                      group.requestId
                                        ? "500"
                                        : "700",
                                  }}
                                >
                                  <span className="date">
                                    {CommonService.formatStrictDate(
                                      group.createdDate
                                    )}
                                  </span>
                                  <span className="time">
                                    {CommonService.formatStrictTime(
                                      group.createdDate
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                              <div className="d-flex justify-content-between message-count-outer">
                                      <p
                                        className="msg-preview mb-0 ps-0"
                                        style={{
                                          fontWeight:
                                            selectedGroup?.requestId ===
                                            group.requestId
                                              ? "500"
                                              : "700",
                                        }}
                                      >
                                        {" "}
                                        {
                                          JSON.parse(group.messages[0])[
                                            JSON.parse(group.messages[0])
                                              .length - 1
                                          ]
                                        }
                                      </p>
                                      {group.unreadMessageCount !== 0 && (
                                        <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                                          {group.unreadMessageCount}
                                        </span>
                                      )}
                                    </div>
                            {/* <div className="d-flex justify-content-between">
              <p className="msg-preview mb-0"
              style={{
                fontWeight:
                selectedGroup?.requestId === group.requestId
                  ? "500"
                  : "700",
          }}>
                {" "}
                {
                  JSON.parse(group.messages[0])[
                    JSON.parse(group.messages[0]).length - 1
                  ]
                }
                ...
              </p>
              {group.unreadMessageCount !== 0 && (
                <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                  {group.unreadMessageCount}
                </span>
              )}
            </div> */}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>

                    {groups.length <= 0 && 
                    <div className={`no-chat-wrapper ${groups.length <= 0 ? "d-block" : "d-none"}`} style={{height:`${tabContainerHeight}px`}}>
                    <NoGroupMessage />
                    </div>}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-warehouse"
                    role="tabpanel"
                    aria-labelledby="nav-warehouse-tab"
                    tabIndex={0}
                  >
                    {/* {selectedGroup ? ( */}
                    <ListGroup className={`${groups.length <= 0 ? "d-none" : "d-block"}`} style={{height:`${tabContainerHeight}px`}} ref={tabContainerRef}>
                      {groups.map((group, index) => (
                        <ListGroup.Item
                          className="cursor-pointer"
                          style={{
                            backgroundColor:
                              selectedGroup?.requestId === group.requestId
                                ? "white"
                                : "initial",
                          }}
                          onClick={() => {
                            setGroupMessagesAsRead(group);
                          }}
                        >
                          <div className="chat-info-wrapper py-2">
                            <div className="chat-info-inner flex-wrap flex-sm-nowrap">
                              <div className="d-flex align-items-start" style={{gap:"12px"}}>
                                <div className="avtar d-inline-flex justify-content-center align-items-center position-relative flex-shrink-0">
                                  {group?.sendBy?.charAt(0)}
                                  <span className="active-status online position-absolute top-0 start-0"></span>
                                </div>
                              
                                <div className="chat__info d-flex d-sm-block flex-column">
                                  {CommonService.isUser() &&
                                    !CommonService.isSameCompany(
                                      group.companyId
                                    ) && (
                                      <span className="chat__info--name">
                                        {" "}
                                        #{group.requestNumber}
                                      </span>
                                    )}
                                  {(CommonService.isAdmin() ||
                                    CommonService.isSameCompany(
                                      group.companyId
                                    )) && (
                                    <>
                                      <span className="chat__info--name">
                                        {group.sendBy}
                                      </span>
                                    </>
                                  )}
                                  <div>
                                    <div className="d-flex align-items-center">
                                      {CommonService.isAdmin() && (
                                        <>
                                          <p className="chat__info--company me-2 mb-0">
                                            {group.companyName}
                                          </p>
                                          <span className="d-none d-sm-inline">
                                            |
                                          </span>
                                        </>
                                      )}
                                      <span className="chat__info--reqType ms-sm-2">
                                        {group.requestType ==
                                          "OFFER_REQUEST" && (
                                          <img
                                            src={OfferPercentage}
                                            alt="OfferPercentage"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SAMPLE_REQUEST" && (
                                          <img
                                            src={SampleDrop}
                                            alt="SampleDrop"
                                          />
                                        )}
                                        {group.requestType ==
                                          "ORDER_REQUEST" && (
                                          <img
                                            src={ShoppingCartSimple}
                                            alt="ShoppingCartSimple"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SELL_REQUEST" && (
                                          <img
                                            src={SellRequestSimple}
                                            alt="SellRequestSimple"
                                          />
                                        )}
                                        {toTitleCase(group.requestType)}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <p className="msg-preview mb-0 ps-0">
                                        {" "}
                                        {
                                          JSON.parse(group.messages[0])[
                                            JSON.parse(group.messages[0])
                                              .length - 1
                                          ]
                                        }
                                      </p>
                                      {group.unreadMessageCount !== 0 && (
                                        <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                                          {group.unreadMessageCount}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="ms-auto">
                                {(CommonService.isAdmin() ||
                                  CommonService.isSameCompany(
                                    group.companyId
                                  )) && (
                                  <>
                                    <span className="chat__info--name">
                                      #{group.requestNumber}
                                    </span>
                                  </>
                                )}
                                <div
                                  className="time__info d-flex flex-column text-end lh-base"
                                  style={{
                                    fontWeight:
                                      selectedGroup?.requestId ===
                                      group.requestId
                                        ? "500"
                                        : "700",
                                  }}
                                >
                                  <span className="date">
                                    {CommonService.formatStrictDate(
                                      group.createdDate
                                    )}
                                  </span>
                                  <span className="time">
                                    {CommonService.formatStrictTime(
                                      group.createdDate
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* <div className="d-flex justify-content-between">
              <p className="msg-preview mb-0">
                {" "}
                {
                  JSON.parse(group.messages[0])[
                    JSON.parse(group.messages[0]).length - 1
                  ]
                }
                ...
              </p>
              {group.unreadMessageCount !== 0 && (
                <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                  {group.unreadMessageCount}
                </span>
              )}
            </div> */}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                    {groups.length <= 0 &&
                    <div className={`no-chat-wrapper ${groups.length <= 0 ? "d-block" : "d-none"}`} style={{height:`${tabContainerHeight}px`}}>
                    <NoGroupMessage/>
                    </div>}
                  </div>
                  <div
                    className="tab-pane fade"
                    id="nav-requests"
                    role="tabpanel"
                    aria-labelledby="nav-requests-tab"
                    tabIndex={0}
                  >
                    {/* {selectedGroup ? (  */}
                    <ListGroup className={`${groups.length <= 0 ? "d-none" : "d-block"}`} style={{height:`${tabContainerHeight}px`}} ref={tabContainerRef}>
                      {groups.map((group, index) => (
                        <ListGroup.Item
                          className="cursor-pointer"
                          style={{
                            backgroundColor:
                              selectedGroup?.requestId === group.requestId
                                ? "white"
                                : "initial",
                          }}
                          onClick={() => {
                            setGroupMessagesAsRead(group);
                          }}
                        >
                          <div className="chat-info-wrapper py-2">
                            <div className="chat-info-inner flex-wrap flex-sm-nowrap">
                              <div className="d-flex align-items-start" style={{gap:"12px"}}>
                                <div className="avtar d-inline-flex justify-content-center align-items-center position-relative flex-shrink-0">
                                  {group?.sendBy?.charAt(0)}
                                  <span className="active-status online position-absolute top-0 start-0"></span>
                                </div>
                              
                                <div className="chat__info d-flex d-sm-block flex-column">
                                  {CommonService.isUser() &&
                                    !CommonService.isSameCompany(
                                      group.companyId
                                    ) && (
                                      <span className="chat__info--name">
                                        {" "}
                                        #{group.requestNumber}
                                      </span>
                                    )}
                                  {(CommonService.isAdmin() ||
                                    CommonService.isSameCompany(
                                      group.companyId
                                    )) && (
                                    <>
                                      <span className="chat__info--name">
                                        {group.sendBy}
                                      </span>
                                    </>
                                  )}

                                  <div>
                                    <div className="d-flex align-items-center">
                                      {(CommonService.isAdmin() ||
                                        CommonService.isSameCompany(
                                          group.companyId
                                        )) && (
                                        <>
                                          <p className="chat__info--company me-2 mb-0">
                                            {group.companyName}
                                          </p>
                                          <span className="d-none d-sm-inline">
                                            |
                                          </span>
                                        </>
                                      )}
                                      <span className="chat__info--reqType ms-sm-2">
                                        {group.requestType ==
                                          "OFFER_REQUEST" && (
                                          <img
                                            src={OfferPercentage}
                                            alt="OfferPercentage"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SAMPLE_REQUEST" && (
                                          <img
                                            src={SampleDrop}
                                            alt="SampleDrop"
                                          />
                                        )}
                                        {group.requestType ==
                                          "ORDER_REQUEST" && (
                                          <img
                                            src={ShoppingCartSimple}
                                            alt="ShoppingCartSimple"
                                          />
                                        )}
                                        {group.requestType ==
                                          "SELL_REQUEST" && (
                                          <img
                                            src={SellRequestSimple}
                                            alt="SellRequestSimple"
                                          />
                                        )}
                                        {toTitleCase(group.requestType)}
                                      </span>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                      <p className="msg-preview mb-0 ps-0">
                                        {" "}
                                        {
                                          JSON.parse(group.messages[0])[
                                            JSON.parse(group.messages[0])
                                              .length - 1
                                          ]
                                        }
                                      </p>
                                      {group.unreadMessageCount !== 0 && (
                                        <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                                          {group.unreadMessageCount}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="ms-auto">
                                {(CommonService.isAdmin() ||
                                  CommonService.isSameCompany(
                                    group.companyId
                                  )) && (
                                  <>
                                    <span className="chat__info--name">
                                      #{group.requestNumber}
                                    </span>
                                  </>
                                )}
                                <div
                                  className="time__info d-flex flex-column text-end lh-base"
                                  style={{
                                    fontWeight:
                                      selectedGroup?.requestId ===
                                      group.requestId
                                        ? "500"
                                        : "700",
                                  }}
                                >
                                  <span className="date">
                                    {CommonService.formatStrictDate(
                                      group.createdDate
                                    )}
                                  </span>
                                  <span className="time">
                                    {CommonService.formatStrictTime(
                                      group.createdDate
                                    )}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {/* <div className="d-flex justify-content-between">
              <p className="msg-preview mb-0">
                {" "}
                {
                  JSON.parse(group.messages[0])[
                    JSON.parse(group.messages[0]).length - 1
                  ]
                }
                ...
              </p>
              {group.unreadMessageCount !== 0 && (
                <span className="msg-count d-inline-flex justify-content-center align-items-center rounded-circle">
                  {group.unreadMessageCount}
                </span>
              )}
            </div> */}
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                    {groups.length <= 0 && 
                    <div className={`no-chat-wrapper ${groups.length <= 0 ? "d-block" : "d-none"}`} style={{height:`${tabContainerHeight}px`}}>
                    <NoGroupMessage />
                    </div>}
                  </div>
                </>
              </div>
              )}
            </div>
          {/* )} */}

          <div className={`message-list-wrapper col-md-6 col-lg-7 col-xl-8 col-xxl-8 position-relative pe-0 ${!selectedGroup ? "no-chat-inbox":"" }`}>
            {selectedGroup ? (
              <WebSocketProvider
                requestId={selectedGroup.requestId}
                sellerCompanyId={
                  isSeller == true ? CommonService.getCompanyId() : null
                }
              >
                {/* <Container> */}

                <div className="message-list-card h-100">
                  {CommonService.isAdmin() &&
                  selectedGroup.requestType != "SELL_REQUEST" &&
                  selectedGroup.requestType != "CUSTOMER_SERVICE_REQUEST" ? (
                    <AdminMessageBox
                      selectedGroup={selectedGroup}
                      requestId={selectedGroup.requestId}
                      requestType={selectedGroup.requestType}
                      unreadGroupsCount={0}
                      setUnreadGroupsCount={() => 0}
                      isSeller={isSeller} containerHeight={innerHeight}
                    />
                  ) : (
                    <MessageBox
                      selectedGroup={selectedGroup}
                      groupRequestId={selectedGroup.requestId}
                      user1="User1"
                      user2={
                        isSeller == true
                          ? CommonService.getCompanyId()
                          : "User2"
                      }
                      searchQuery={searchQuery}
                      requestType={selectedGroup.requestType}
                      isSeller={isSeller}
                      height={innerHeight}
                    />
                  )}
                </div>
                {/* </Container> */}
              </WebSocketProvider>
            ) : (
              <NoChatMessage />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupMessageBox;